import React from 'react'
import classNames from 'classnames'
import { TwoButtonsProps } from './TwoButtons.d'
import { getSize, getVariation } from '@toasttab/shared/src/utils/Craft/button'
import Button from '@toasttab/shared/src/components/atoms/Button/Button'

const TwoButtons = ({ buttons, classes }: TwoButtonsProps) => {
  const cssClasses = classNames(
    classes,
    'flex flex-wrap gap-4 ds-hero__two-buttons',
    {
      'mb-6': !classes
    }
  )
  const renderButtons = () => {
    return buttons.map((button, i) => {
      const buttonClass = classNames(
        'px-0 md:flex-grow-0 md:w-auto',
        button.classes
      )

      return (
        <Button
          href={button.ctaLink}
          size={getSize(button.buttonPadding)}
          variation={getVariation(button.buttonVariations)}
          classes={buttonClass}
          key={i}
          fullwidth={button.buttonPadding === 'Full Width'}
          fontWeight={['font-semibold']}
          numComponents={i + 1}
        >
          {button.ctaLabel}
        </Button>
      )
    })
  }

  return <div className={cssClasses}>{renderButtons()}</div>
}

export default TwoButtons
